import { Injectable } from "@angular/core";
//import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Section } from '../models/section';
import { Student } from '../models/student';
import { Area } from '../models/area';
import { AreaItem } from "../models/area-item";
import { addDoc, collection, collectionData, doc, Firestore, getDocs, orderBy, query, setDoc } from "@angular/fire/firestore";

@Injectable()
export class MigrationService {

    //private db: AngularFirestore;
    constructor(private firestore: Firestore) {
        const settings = { timestampsInSnapshots: true };
        //db.firestore.settings(settings:);
        //this.db = afs;
    }


   /**
    *   06.05.2025: Cada año se debe correr el proceso en orden:
      -  createSection (crea las secciones)
      -  createStudents (migra los estudiantes al siguiente año)
      -  creteReportCards (crea las libretas)
      -  createReportAreas (copia las libretas del año anterior en la nueva)
    * @param year
    */
    async migrateProcess(year: number): Promise<void> {

        //2026: 21 de abril de 2026
        // this.createSection(2, 'Semillitas - 2 años', 'child_friendly', year, '');
        // this.createSection(3, 'Sonrisas - 3 años', 'child_care', year, 'Miss Mayumi');
        // this.createSection(4, 'Amistad - 4 años', 'directions_run', year, 'Miss Priscila');
        // this.createSection(5, 'Alegría - 5 años', 'local_library', year, 'Miss Mery');

        // this.createStudents(`${year-1}-2`, `${year}-3`);
        // this.createStudents(`${year-1}-3`, `${year}-4`);
        // this.createStudents(`${year-1}-4`, `${year}-5`);

        // this.createReportCards(year, 2);
        // this.createReportCards(year, 3);
        // this.createReportCards(year, 4);
        // this.createReportCards(year, 5);

        //this.createReportAreas(year -1, year, 2); //2025, 2026
        await this.createReportAreas(year - 1, year, 3);
        await this.createReportAreas(year - 1, year, 4);
        await this.createReportAreas(year - 1, year, 5);

        alert("Process completed - create reports areas");
    }

    createSection(section: number, sectionName: string, icon: string, year: number, teacher: string) {

      const sectionId = `${year.toString()}-${section.toString()}`;
      var sectionDocRef = doc(this.firestore, 'sections', sectionId);

      setDoc(sectionDocRef, {
          name: sectionName,
          icon: icon,
          teacher: teacher,
          year: year
      });
    }

    /**
     * Migrate students from last year to the new year.
     * @param sectionOriginal
     * @param sectionNew
     */
    createStudents(sectionOriginal: string, sectionNew: string) {
        // var studentCollection = this.db.collection<Student>('sections/' + sectionOriginal + '/students');
        var studentCollection = collection(this.firestore, `sections/${sectionOriginal}/students`);

        // var newStudentCollection = this.db.collection<Student>('sections/' + sectionNew + '/students');
        var newStudentCollection = collection(this.firestore, `sections/${sectionNew}/students`);

        let students$ = collectionData<any>(studentCollection);

        students$.subscribe(students => {
          students.forEach(student => {

            //console.log(sectionOriginal, student);

            addDoc(newStudentCollection, {
              name: student.name,
              fatherName: student.fatherName,
              motherName: student.motherName
            });
          })
        });


        // studentCollection.ref.get().then(a => {
        //     a.docs.forEach(function (value, index, data) {
        //         let info = value.data();

        //         newStudentCollection.add({
        //             name: info.name,
        //             fatherName: info.fatherName,
        //             motherName: info.motherName
        //         });
        //     })
        // })
    }

    //Crear los bimestres de cada ño
    createReportCards(year: number, section: number) {

      let sectionName = `${year}-${section}`;

      setDoc(doc(this.firestore, `sections/${sectionName}/templates/first`), {
        icon: 'looks_one',
        name: 'Primer Bimestre ' + year
      });
      setDoc(doc(this.firestore, `sections/${sectionName}/templates/second`), {
        icon: 'looks_two',
        name: 'Segundo Bimestre ' + year
      });
      setDoc(doc(this.firestore, `sections/${sectionName}/templates/third`), {
        icon: 'looks_3',
        name: 'Tercer Bimestre ' + year
      });
      setDoc(doc(this.firestore, `sections/${sectionName}/templates/fourth`), {
        icon: 'looks_4',
        name: 'Cuarto Bimestre ' + year
      });
    }

    /**
     * Copia los items del año anterior en el actual
     * @param lastYear
     * @param currentYear
     * @param section
     */
    async createReportAreas(lastYear: number, currentYear: number, section: number) {
        let lastSection = `${lastYear}-${section}`;
        let currentSection = `${currentYear}-${section}`;

        let templates = ['first', 'second', 'third', 'fourth'];
        //let templates = ['third'];

        for (const template of templates) {
          var lastAreaCollection = query(
            collection(this.firestore, `sections/${lastSection}/templates/${template}/areas`),
            orderBy('order')
          );

          var currentAreaCollection = collection(this.firestore, `sections/${currentSection}/templates/${template}/areas`);

          const lasAreasSnap = await getDocs(lastAreaCollection);
          for (const lastAreaDoc of lasAreasSnap.docs) {

            const lastArea = lastAreaDoc.data();
            const lastAreaId = lastAreaDoc.id;

            const valueRef = await addDoc(currentAreaCollection, {
                name: lastArea.name,
                order: lastArea.order,
                date: new Date(),
                createdBy: 'internal.migration',
                modifiedBy: ''
              });

            const lastItemsCollection = query(
                collection(this.firestore, `sections/${lastSection}/templates/${template}/areas/${lastAreaId}/items`),
                orderBy('order')
              );

            const lasItemsSnap = await getDocs(lastItemsCollection);
            const currentItemsCollection = collection(this.firestore, `sections/${currentSection}/templates/${template}/areas/${valueRef.id}/items`);

            for (const lastItemDoc of lasItemsSnap.docs) {
              const lastItem = lastItemDoc.data();
              await addDoc(currentItemsCollection, {
                        name: lastItem.name,
                        order: lastItem.order,
                        date: lastItem.date,
                        createdBy: 'internal.migration',
                        modifiedBy: ''
              });
            }

          }
        }

        // templates.forEach(template => {

        //   collectionData<any>(lastAreaCollection, { idField: 'id'}).subscribe(lastAreas => {
        //     lastAreas.forEach(lastArea => {

        //       const lastItemsCollection = query(
        //         collection(this.firestore, `sections/${lastSection}/templates/${template}/areas/${lastArea.id}/items`),
        //         orderBy('order')
        //       );

        //       console.log(`last section: ${lastSection}-${template}, id: ${lastArea.id}, area: ${lastArea.name}, order: ${lastArea.order}, date: ${lastArea.date}`);

        //       addDoc(currentAreaCollection, {
        //         name: lastArea.name,
        //         order: lastArea.order,
        //         date: new Date(),
        //         createdBy: 'internal.migration',
        //         modifiedBy: ''
        //       }).then(valueRef => {

        //           //console.log('Value Ref created: ', valueRef.id);
        //           const currentItemsCollection = collection(this.firestore, `sections/${currentSection}/templates/${template}/areas/${valueRef.id}/items`);

        //           collectionData<any>(lastItemsCollection).subscribe(lastItems => {
        //             lastItems.forEach(lastItem => {

        //               //console.log(`last section: ${lastSection}-${template}, area: ${lastArea.name}, item: ${lastItem.name}, order: ${lastItem.order}`);
        //               addDoc(currentItemsCollection, {
        //                 name: lastItem.name,
        //                 order: lastItem.order,
        //                 date: lastItem.date,
        //                 createdBy: 'internal.migration',
        //                 modifiedBy: ''
        //               });

        //             });
        //           });

        //         });

        //     });
        //   });

        //  });
    }

    createReportItems(lastYear: number, currentYear: number, section: number) {

        let lastSection = lastYear + '-' + section;
        let currentSection = currentYear + '-' + section;

        let templates = ['first', 'second', 'third', 'fourth'];

        // templates.forEach( template => {

        //     var lastAreaCollection = this.db.collection<Area>('sections/' + lastSection + '/templates/' + template + '/areas');

        //     lastAreaCollection.ref.get().then(a => {
        //         a.docs.forEach(value => {
        //             let info = value.data();

        //             var originalItems = this.db.collection<AreaItem>('sections/' + lastSection + '/templates/' + template + '/areas/' + value.id);
        //             var currentItems = this.db.collection<AreaItem>('sections/' + currentSection + '/templates/' + template + '/areas/' + value.id);

        //             originalItems.ref.get().then(b => {
        //                 b.docs.forEach(bValue => {
        //                     let itemInfo = bValue.data();

        //                 })

        //             });

        //         })
        //     });


        // });


    }

}
